module.exports = __webpack_public_path__ + "img/background062.ca1b48c0.jpg";